/* global products */

jQuery(document).ready(function ($) {
    $('.js-filter-overview').on('click', redirect);
    $('.js-filter-selected').on('click', removeFilter);

    $('.js-search').bind("enterKey", redirect).keyup(function (e) {
        if (e.keyCode == 13) {
            $(this).trigger("enterKey");
        }
    });

    $('.js-toggle-tax').on('change', toggle_tax);

    $('.js-toggle-option').on('change', toggle_option);

    $('input[name="quantity"]').on('change input', function(){
        const $this = $(this),
            container = $this.closest('.quantity'),
            surfaceContainer = container.find('.quantity-surface'),
            surface = parseFloat(surfaceContainer.attr('data-surface')) * parseFloat($this.val());

        surfaceContainer.text(surface.toFixed(2));

    });

    function removeFilter() {
        var currentUrl = window.location.href,
            parent = $(this).closest(".row-overview"),
            keyToRemove = $(this).attr("data-tax"),
            updatedUrl = "";

        if (keyToRemove) {
            keyToRemove = keyToRemove.replace("_", "-");

            currentUrl.searchParams.delete(keyToRemove);

            updatedUrl = currentUrl.origin + currentUrl.pathname;
            if (currentUrl.searchParams.toString()) {
                updatedUrl += "?" + currentUrl.searchParams.toString();
            }
        } else {
            const search = $(".js-search"),
                hasSearch = search.val().trim() !== "";

            const baseHref = parent.find("a").attr("href") || window.location.pathname;

            if (hasSearch) {
                const nextUrl = new URL(baseHref, currentUrl.origin);
                nextUrl.searchParams.set(search.attr("name"), search.val().trim());
                updatedUrl = nextUrl.toString();
            } else {
                updatedUrl = baseHref;
            }
        }

        if (updatedUrl.endsWith("?")) {
            updatedUrl = updatedUrl.slice(0, -1);
        }

        window.location.href = updatedUrl;
    }

    function redirect() {

        const $this = $(this),
            parent = $this.closest('.row-overview'),
            filterContainer = $this.closest('ul'),
            fields = parent.find('.js-collapsible__content, input'),
            url = {};

        filterContainer.find('.is-active').removeClass('is-active');
        $this.addClass('is-active');

        $.each(fields, function () {
            const $this = $(this);

            switch (true) {
                case $this.hasClass('js-collapsible__content'):
                    if ($this.find('.is-active').attr('data-slug')) {
                        url[$this.attr('data-tax').replace('_', '-')] = $this.find('.is-active').attr('data-slug');
                    }
                    break;
                case $this.is("input"):
                    if ($this.val()) {
                        url[$this.attr('name')] = $this.val();
                    }
                    break;
            }
        });

        const baseHref = products?.baseUrl?.replace(/\/$/, '') ?? window.location.origin;
        const productType = url["product-type"] || "";
        delete url["product-type"];

        const target = productType ? `${baseHref}/${productType}/` : `${baseHref}/`;

        const params = $.param(url);
        window.location.href = params ? `${target}?${params}` : target;

        return false;
    }

    function toggle_tax(){
        const $this = $(this),
            block = $this.closest('.u-content-row'),
            product = block.find('.row-overview__item');

        switch(true){
            case $this.is(':checked') && options.taxDisplay === 'incl':
            case !$this.is(':checked') && options.taxDisplay === 'excl':
                product.find('.price').stop().slideDown();
                product.find('.price-alt').stop().slideUp();
                break;
            case !$this.is(':checked') && options.taxDisplay === 'incl':
            case $this.is(':checked') && options.taxDisplay === 'excl':
                product.find('.price').stop().slideUp();
                product.find('.price-alt').stop().slideDown();
                break;
        }
    }

    function toggle_option(){
        const $this = $(this),
        block = $this.closest('.row-product');

        calculate_price(block);
    }

    function calculate_price(block) {
        $.each(block.find('.price > del bdi, .price > .woocommerce-Price-amount bdi'), function () {
            $(this).html(format_currency(calculating_price(product.price.regular)));
        });

        $.each(block.find('.price > ins bdi'), function () {
            $(this).html(format_currency(calculating_price(product.price.sale)));
        });
    }

    function calculating_price(price) {
        const length = get_dimension('length'),
            width = get_dimension('width'),
            surface = length * width,
            assemblyCostsField = $('input[name="assemblyCosts"]'),
            assemblyCostsOptions = options.assemblyCosts;

        if(!assemblyCostsOptions.price > 0 ){
            return price;
        }

        let calculatedPrice = parseFloat(price);

        if (assemblyCostsField.is(':checked')) {
            calculatedPrice += parseFloat(assemblyCostsOptions.price) * surface;
        }

        return calculatedPrice;
    }

    function get_dimension(dimension) {
        return parseFloat(product.dimensions[dimension]) / 100;
    }

    function format_currency(number) {
        return new Intl.NumberFormat('nl-NL', {
            style: 'currency',
            currency: 'EUR',
        }).format(number)
    }

});